import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { sessionApi, type SessionResponse } from '../api/client'
import { AuthFlowPage } from '../components/AuthFlowPage'
import { AuthLayout, AuthLoading } from '../components/AuthLayout'
import { ErrorMessage } from '../components/ErrorMessage'
import { useI18n } from '../i18n'

export default function HomePage() {
  const { t } = useI18n()
  const [searchParams] = useSearchParams()
  const inFlow = ['flow', 'login_challenge', 'return_to', 'refresh'].some(name => searchParams.has(name))
  const [session, setSession] = useState<SessionResponse | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (inFlow) return
    let active = true
    setLoading(true)
    setError(null)
    setSession(null)
    sessionApi.checkSession()
      .then(response => { if (active) setSession(response.data) })
      .catch(() => { if (active) setError('Unable to check your session. Please try again.') })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [inFlow])

  if (inFlow) return <AuthFlowPage kind="login" home />
  if (loading) {
    return <AuthLayout title={t('Sign in')}>
      <AuthLoading />
    </AuthLayout>
  }
  if (error) {
    return <AuthLayout title={t('Sign in')}>
      <ErrorMessage message={t(error)} />
      <button className="mt-4 w-full btn-primary" onClick={() => window.location.reload()}>{t('Try again')}</button>
    </AuthLayout>
  }
  if (!session?.active) return <AuthFlowPage kind="login" home />

  return (
    <AuthLayout title={t('Welcome back!')} description={t('Use your TOGA account across connected applications.')}>
      <p className="text-center text-sm text-gray-600 break-words">
        {t('You are signed in as {email}', { email: session.identity?.email || '' })}
      </p>
      <div className="mt-6 flex flex-col gap-3">
        <Link to="/settings" className="w-full btn-primary text-center">{t('Account settings')}</Link>
        <Link to="/logout" className="w-full btn-secondary text-center">{t('Sign out')}</Link>
      </div>
    </AuthLayout>
  )
}
